import { ComponentType, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { Spinner } from 'components/Spinner';

export const withPlaygroundEnabled = <P extends Record<string, unknown>>(Component: ComponentType<P>) => {
  return (props: P) => {
    const router = useRouter();
    const { modelPlaygroundLDFF } = useFeatureFlagsLD();

    useEffect(() => {
      if (modelPlaygroundLDFF === false) {
        router.push('/explore');
      }
    }, [modelPlaygroundLDFF]);

    if (!modelPlaygroundLDFF) {
      return <Spinner />;
    }

    return <Component {...props} />;
  };
};
